import { Store } from '@ngxs/store';
import { LearningUnitEntity } from './learning-unit-entity';
import { LearningUnitEntityService } from './services/learning-unit.entity.service';
import { LearningSectionEntity } from '../learning-section/learning-section-entity';
import { LearningSectionEntityService } from '../learning-section/services/learning-section.entity.service';
import { EntityStateModel } from '../core/state/entity.state';
import { makeQueryKey } from '../utils/entity-states/query-key';
import { RelationTableColumn } from '../utils/component/relation-table/relation-table.types';

export function getLearningUnitColumns(
  store: Store,
  learningSectionService: LearningSectionEntityService
): RelationTableColumn[] {
  return [
    { key: 'id', label: 'ID' },
    { key: 'title', label: 'title' },
    {
      key: 'learningSections',
      label: 'learning_sections',
      valueFn: (row: LearningUnitEntity) => {
        const refs = row.learningSections;
        if (!refs || !Array.isArray(refs) || refs.length === 0) {
          return '';
        }
        const state = store.selectSnapshot(learningSectionService.stateClass);
        return refs
          .map(ref => {
            const id = typeof ref === 'string' ? ref : ref.id;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const entity = (state as any)?.entities?.[id] as LearningSectionEntity | undefined;
            return entity?.name ?? '';
          })
          .filter(name => name.length > 0)
          .join(', ');
      }
    },
  ];
}

export function getLoadLearningUnitsFn(
  store: Store,
  learningUnitService: LearningUnitEntityService
): (params: { page: number, pageSize: number, search: string }) => Promise<{ data: LearningUnitEntity[], total: number }> {
  return async (params: { page: number, pageSize: number, search: string }) => {
    const query: Record<string, unknown> = {
      'page[size]': params.pageSize,
      'page[number]': params.page,
      'sort': 'title',
      'include': 'learningSections',
    };
    if (params.search?.trim()) {
      query['filter[idOrTitleLike]'] = params.search.trim();
    }
    await learningUnitService.ensureLoaded(query);
    const data = store.selectSnapshot(learningUnitService.allByQuery(query));

    const state = store.selectSnapshot(learningUnitService.stateClass) as EntityStateModel<LearningUnitEntity>;
    const queryKey = makeQueryKey(query);
    const total = state?.meta?.[queryKey]?.page?.total ?? 0;

    return { data, total };
  };
}
